// extracted by mini-css-extract-plugin
export default {"card":"CollectionHelp_card__wB7wt"};